export default __webpack_public_path__ + "static/media/icon-menu-package.2eeff69e.svg";